<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <v-layout row>
            <v-flex xs10>
              <h3>{{ mail.title }}</h3>
            </v-flex>
            <v-flex 
              xs2 
              class="text-xs-right"
            >
              <span class="caption">{{ printDate(mail.created) }}</span>
            </v-flex>
          </v-layout>
          <div>
            <v-divider />
            <v-divider class="mt-1 mb-1" />
            <p 
              class="mt-2"
              v-html="mail.message"
            ></p>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'mail-view',
  metaInfo () {
    return { title: 'Mail' }
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('member', [
      'inbox'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    mail () {
      return this.inbox.find(i => parseInt(i.id) === parseInt(this.id))
    }
  },
  methods: {
    printDate (d) {
      const d2 = moment(d)
      return d2.format('DD-M-YY')
    }
  },
  async created () {
    await this.$store.dispatch('member/markMailAsRead', this.mail)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mail.vue